import { FC } from 'react'

import { IconPlay } from 'components/icons/play-icon'
import { IconSoundOn } from 'components/icons/sound-on-icon'
import { FormattedDuration } from './formatted-duration'
import {
  PlayButton,
  Container,
  Slider,
  Time,
  Year,
  TotalLength,
} from './styled'
import { YearCounter } from './year-counter'
import { IconPause } from 'components/icons/pause-icon'
import { IconSoundOff } from 'components/icons/sound-off-icon'
import { IconSoundOffCircle } from 'components/icons/sound-off-circle-icon'

type Props = {
  year: string
  currentTime: number
  duration: number
  isPlaying: boolean
  isHomepage: boolean
  isMuted: boolean
  onSlide: (value: number) => void
  onPlay: () => void
  onPause: () => void
  onMuteToggle: () => void
}

export const Player: FC<Props> = ({
  year,
  currentTime,
  duration,
  isPlaying,
  isMuted,
  isHomepage,
  onSlide,
  onPlay,
  onPause,
  onMuteToggle,
}) => {
  if (isHomepage) {
    return null
  }

  return (
    <Container>
      <Year>
        <YearCounter value={year} />
      </Year>

      {year ? (
        <>
          {isPlaying ? (
            <PlayButton onClick={onPause}>
              <IconPause />
            </PlayButton>
          ) : (
            <PlayButton onClick={onPlay}>
              <IconPlay />
            </PlayButton>
          )}
          <Time>
            <FormattedDuration value={currentTime} />
            <TotalLength>
              {' '}
              / <FormattedDuration value={duration} />
            </TotalLength>
          </Time>
          <Slider
            max={Math.round(duration)}
            value={Math.round(currentTime)}
            onChange={evt => onSlide(evt.currentTarget.valueAsNumber)}
          />
        </>
      ) : (
        <>
          <PlayButton disabled>
            <IconPlay />
          </PlayButton>
          <Time>
            <FormattedDuration value={0} />
            <TotalLength>
              {' '}
              / <FormattedDuration value={0} />
            </TotalLength>
          </Time>
          <Slider max={0} value={0} disabled />
        </>
      )}
      <PlayButton onClick={onMuteToggle} $isMute>
        {isMuted ? <IconSoundOffCircle /> : <IconSoundOn />}
      </PlayButton>
    </Container>
  )
}
